<p-dropdown
    #dropdown
    [filter]="to.filter"
    [options]="getOptions(to.options)"
    [styleClass]="styleClass"
    [editable]="editable"
    [formControl]="formControl"
    (onChange)="selectionChanged($event)"
    [placeholder]="' '"
    [autofocusFilter]="false"
    [disabled]="to.disabled"
>
    <ng-template let-option pTemplate="selectedItem">
        <span [innerHTML]="option.label"></span>
    </ng-template>
    <ng-template let-option pTemplate="item">
        <span [innerHTML]="option.label"></span>
    </ng-template>
</p-dropdown>
<div *ngIf="to.description">
    <small class="text-muted">
        {{ to.description }}
    </small>
</div>
